import { render, staticRenderFns } from "./customer-register.vue?vue&type=template&id=b4e6f6b6"
import script from "./customer-register.vue?vue&type=script&lang=js"
export * from "./customer-register.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports